import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(() => {
    const raw = localStorage.getItem("cf_session");
    return raw ? JSON.parse(raw) : null;
  });
  const [businessToken, setBusinessToken] = useState(() => localStorage.getItem("cf_business_token"));
  const [business, setBusiness] = useState(() => {
    const raw = localStorage.getItem("cf_business");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cf_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setSession(r.data);
        localStorage.setItem("cf_session", JSON.stringify(r.data));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const businessLogin = async (email, password) => {
    const r = await api.post("/auth/business-login", { email, password });
    localStorage.setItem("cf_business_token", r.data.business_token);
    localStorage.setItem("cf_business", JSON.stringify(r.data.business));
    setBusinessToken(r.data.business_token);
    setBusiness(r.data.business);
    return r.data.business;
  };

  const staffLogin = async (username, password) => {
    const bt = businessToken || localStorage.getItem("cf_business_token");
    const r = await api.post(
      "/auth/staff-login",
      { username, password },
      { headers: { Authorization: `Bearer ${bt}` } }
    );
    localStorage.setItem("cf_token", r.data.session_token);
    const sess = {
      business_id: r.data.business.id,
      business_name: r.data.business.name,
      business_email: r.data.business.email,
      staff: r.data.staff,
      roles: r.data.staff.roles || {},
    };
    localStorage.setItem("cf_session", JSON.stringify(sess));
    setSession(sess);
    return sess;
  };

  const switchStaff = () => {
    // Keep business token, clear session only
    localStorage.removeItem("cf_token");
    localStorage.removeItem("cf_session");
    setSession(null);
  };

  const switchBusiness = () => {
    localStorage.removeItem("cf_token");
    localStorage.removeItem("cf_session");
    localStorage.removeItem("cf_business_token");
    localStorage.removeItem("cf_business");
    setSession(null);
    setBusiness(null);
    setBusinessToken(null);
  };

  const refreshStaffList = async () => {
    const bt = businessToken || localStorage.getItem("cf_business_token");
    if (!bt) return [];
    try {
      const r = await api.get("/auth/staff-list", { headers: { Authorization: `Bearer ${bt}` } });
      return r.data;
    } catch { return []; }
  };

  const setSessionFromRegister = (data) => {
    // data = {business_token, session_token, business}
    localStorage.setItem("cf_business_token", data.business_token);
    localStorage.setItem("cf_business", JSON.stringify(data.business));
    localStorage.setItem("cf_token", data.session_token);
    setBusinessToken(data.business_token);
    setBusiness(data.business);
    // dispara /auth/me pra carregar roles reais da sessão
    api.get("/auth/me")
      .then((r) => {
        setSession(r.data);
        localStorage.setItem("cf_session", JSON.stringify(r.data));
      })
      .catch(() => {});
  };

  const isAdmin = !!session?.roles?.admin;
  const isVendedor = !!session?.roles?.vendedor;
  const isCobrador = !!session?.roles?.cobrador;

  return (
    <AuthCtx.Provider value={{
      session, business, businessToken, loading,
      businessLogin, staffLogin, switchStaff, switchBusiness, refreshStaffList,
      setSessionFromRegister,
      isAdmin, isVendedor, isCobrador,
    }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
